import type { BackstageTypography } from '@backstage/theme';
import './fonts.css';

// Roboto is the previous application font, kept as the fallback.
export const essityFontFamily = 'Graphik, Roboto, sans-serif';

const heading = (
  fontSize: number,
  fontWeight: number,
  marginBottom: number,
) => ({ fontSize, fontWeight, marginBottom });

// Graphik Light for the page title, Graphik Semibold for other headings.
export const essityTypography: BackstageTypography = {
  htmlFontSize: 16,
  fontFamily: essityFontFamily,
  h1: heading(64, 300, 16),
  h2: heading(48, 600, 14),
  h3: heading(36, 600, 12),
  h4: heading(30, 600, 10),
  h5: heading(24, 600, 8),
  h6: heading(20, 600, 6),
};
